import {Swiper, Navigation, Keyboard, SwiperOptions} from "swiper"

Swiper.use([Navigation, Keyboard])

const sliderSections = document.querySelectorAll(".s-estate-detail-intro")

sliderSections.forEach((slideSection) => {
  const slider = slideSection.querySelector<HTMLElement>(".s-estate-detail-intro__slider")
  const buttonPrev = slideSection.querySelector<HTMLElement>(".swiper-button-prev")
  const buttonNext = slideSection.querySelector<HTMLElement>(".swiper-button-next")

  if (!slider) return

  const swiperSettings: SwiperOptions = {
    navigation: {
      nextEl: buttonNext,
      prevEl: buttonPrev,
    },
    keyboard: true,
    slidesPerView: 1,
    spaceBetween: 0,
    updateOnWindowResize: true,
    initialSlide: 0,
    rewind: true,
    // autoHeight: true,
  }

  new Swiper(slider, swiperSettings)
})
